import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { Emojis } from "./emojis";
import { Emoji } from "./emoji.types";
import { TranslateModule } from "@ngx-translate/core";
import { FormBuilder, ReactiveFormsModule } from "@angular/forms";
import { debounceTime, distinctUntilChanged, startWith, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: "tm-emoji-picker",
    templateUrl: 'emoji-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ReactiveFormsModule,
    ]
})
export class TmEmojipickerComponent implements OnInit, OnDestroy {

    protected emojis: Emoji[] = []

    protected show: boolean = false;

    protected searchInputCtrl = this.formBuilder.nonNullable.control<string>('');

    protected searchLoading: boolean = false;

    private _destroy$ = new Subject<void>();

    @Output()
    onAddElement: EventEmitter<Emoji> = new EventEmitter<Emoji>()

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit() {
        this.emojis = Emojis.filter(emoji => emoji.group === 0)

        this.searchInputCtrl.valueChanges.pipe(
            tap(() => this.searchLoading = true),
            startWith(''),
            debounceTime(250),
            distinctUntilChanged(),
            tap(search => {
                if (search) {
                    this.emojis = Emojis.filter(emoji => emoji.tags.some(tag => tag.includes(search)));
                } else {
                    this.emojis = Emojis.filter(emoji => emoji.group === 0);
                }
                this.searchLoading = false;
            }),
            takeUntil(this._destroy$)
        ).subscribe()
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    addEmoji(emoji: Emoji): void {
        this.onAddElement.next(emoji);
        this.show = false;
    }
}
